<template>
    <div class="all_tw">
        <div class="top_tw">
            <div class="logo_tw"><img src="../assets/img/tw-pics/logo_tw.png" wdth="800" height="100"/></div>
        </div>
        <div class="main_tw">
            <a href="javascript:;" class="jcwsglnlts" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">基层卫生<br>管理能力提升</span>
            </a>
            <a href="javascript:;" class="jtysqyfwnljs" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">家庭医生签约<br>服务能力建设</span>
            </a>
            <a href="javascript:;" class="qkyxzljnts" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">全科医学诊疗技能提升<br>与中医药适宜技术应用</span>
            </a>
            <a href="javascript:;" class="jcsqhljnts" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">基层社区<br>护理技能提升</span>
            </a>
	     <!--
            <a href="javascript:;" class="xcyszx" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">乡村医生专项</span>
            </a>
	    -->
            <a href="javascript:;" class="sqqlyjryzx" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">社区七类<br>医技人员专项</span>
            </a>
            <a href="javascript:;" class="jszgfwzxzx" @click="loginVisible = true">
                <span class="mainBoxPic_tw"></span>
                <span class="mainBoxTxt_tw">计生专干服务<br>转型专项</span>
            </a>
        </div>
        <div class="footer_tw">河北省卫生健康委员会 &copy; 版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持：北京亿和博嘉教育科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客服热线：400-004-2055</div>
        <!--学员登录弹出层-->
        <el-dialog
                title="系统登录"
                :visible.sync="loginVisible"
                width="27%">
            <div class="nlb_main">
                <div class="nlb_main_role">
                    <a href="javascript:;" :class="[loginActive === 1 ? 'nlb_main_role_sel' : '']" @click="switchLoginHandle(1)">学&nbsp;员</a>
                    <a href="javascript:;" :class="[loginActive === 2 ? 'nlb_main_role_sel' : '']" @click="switchLoginHandle(2)">管理员</a></div>
                <div class="nlb_box" style="display: block" v-show="loginActive === 1">
                    <div class="nlb_input">
                        <input type="text" v-model="username" placeholder="用户名/身份证/手机号">
                    </div>
                    <div class="nlb_input">
                        <input type="password" v-model="password" placeholder="密码">
                    </div>
                    <div class="nlb_btn">
                        <input type="button" @click="loginHandle" value="登　录">
                    </div>
                    <div class="gdmtl_main_other">
                        <label class="gdmtl_main_other_reg"><a :href="wwwUrl+'register'" class="gdmtl_main_other_reg">注册帐号</a></label>
                        <label class="gdmtl_main_other_for"><a :href="wwwUrl+'findByMobile'" class="gdmtl_main_other_for">忘记密码？</a></label>
                    </div>
                </div>
                <div class="nlb_box" v-show="loginActive === 2">
                    <div class="nlb_input">
                        <input type="text" v-model="username" placeholder="请输入用户名">
                    </div>
                    <div class="nlb_input">
                        <input type="password" v-model="password" placeholder="请输入密码">
                    </div>
                    <div class="nlb_btn">
                        <input type="button" @click="loginHandle" value="登　录">
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {teachManageLogin,login,trainingOfUser,trainings,getServerNowTime} from '../api/api';
    import md5 from 'crypto-js/md5'
    import jsonp from 'jsonp';
    import { Loading } from 'element-ui';


    export default {
        name: 'index',
        components: {},
        data() {
            return {
                loginVisible:false,
                username:'',
                password:'',
                loginActive:1,
                trainingType:103142,
                wwwUrl:process.env.VUE_APP_WEB30_URL
            }
        },

        mounted() {
        },
        methods: {
            loginHandle(){
                console.log(this.loginActive)
                if(this.loginActive === 1){
                    login({
                        username: this.username,
                        password: md5(this.password).toString()
                    }).then((loginRes) => {
                        if (loginRes.data.userInfo) {
                            let gdjcwsTrainings = []
                            trainings({
                                trainingType:this.trainingType
                            }).then((trainingsRes) => {
                                gdjcwsTrainings = trainingsRes.data.list;

                                /*查询用户已经参加的培训班（不包含已过时的）*/
                                const params={excludeExpire:true,trainingWay:1};
                                let trainingId=0
                                trainingOfUser(loginRes.data.userInfo.id,params).then((trainingOfUserRes) => {
                                    const trainings = trainingOfUserRes.data.list;
                                    for (let i = 0; i <trainings.length ; i++) {
                                        for (let j = 0; j < gdjcwsTrainings.length; j++) {
                                            if(trainings[i].id===gdjcwsTrainings[j].id){
                                                trainingId=trainings[i].id
                                                break
                                            }
                                        }
                                    }
                                    Loading.service({ fullscreen: true,text:'登录中...' });
                                    window.location.href = process.env.VUE_APP_WEB30_URL + "usercenter/index?trainingId=" + trainingId+"&token="+loginRes.data.token+'&logoutUrl='+window.location.href;
                                })
                            })
                        } else {
                            this.$message.info(loginRes.data.msg);
                        }
                    })
                }else if(this.loginActive === 2){
                    teachManageLogin({
                        username: this.username,
                        password: md5(this.password).toString()
                    }).then(({data}) => {
                        if (data.status == 200) {
                            Loading.service({ fullscreen: true,text:'登录中...' });
                            window.location.href = process.env.VUE_APP_TEACH_ADMIN_URL + '?token=' + data.data.token + '&logoutUrl=' + window.location.href;
                        } else {
                            this.$message.info(data.msg);
                        }
                    })
                }else{
                    jsonp(process.env.VUE_APP_EXAM_API_URL + '/auth/checklogin?username=' + this.username + "&password=" + md5(this.password).toString()
                        , (err, data) => {
                            if (err) {
                                this.$message.info('未知错误！');
                                return null;
                            } else {
                                if (data.data == true) {
                                    getServerNowTime().then((response) => {
                                        var ts = this.$moment(response.data).valueOf();
                                        let fp = md5(this.username + ts + "INDEX").toString().toUpperCase();
                                        let reUrl = process.env.VUE_APP_EXAM_MANAGE_API_URL + "/login/oauth2"
                                            + "?" + "turl=" + process.env.VUE_APP_EXAM_MANAGE_API_URL + "/main" //目标地址
                                            + "&" + "eurl=" + window.location.href // 退出登录回调地址
                                            + "&" + "ts=" + ts
                                            + "&" + "from=" + "INDEX"
                                            + "&" + "userName=" + this.username
                                            + "&" + "fp=" + fp
                                            + "&" + "ec=" + 1;
                                        Loading.service({ fullscreen: true,text:'登录中...' });
                                        window.location.href = reUrl;
                                    })
                                } else {
                                    this.$message.info(data.message);
                                }
                            }
                        });
                }
            },
            switchLoginHandle(loginActive){
                this.username='';
                this.password='';
                this.loginActive=loginActive
            }
        }
    }
</script>

<style scoped>
    * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        font-family: "微软雅黑";
    }

    body, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, blockquote, th, td {
        margin: 0;
        padding: 0;
        list-style: none;
        color: #000;
    }

    tbody, thead {
        margin: 0px;
        padding: 0px;
        list-style: none;
    }

    p {
        margin: 0px;
        padding: 0px;
        list-style: none;
    }

    .clear {
        display: block;
        overflow: hidden;
        clear: both;
        height: 0;
        line-height: 0;
        font-size: 0;
    }

    li {
        list-style: none;
    }

    body fieldset, body img {
        border: 0;
    }

    a, a:link {
        color: #444;
        text-decoration: none;
    }

    a:hover {
        color: #0258b0;
        text-decoration: none;
    }

    .all_tw {
        background: url(../assets/img/tw-pics/body_tw.png) repeat-x left top #cfe9f8;
    }

    .top_tw {
        width: 100%;
        min-width: 1000px;
        background: url(../assets/img/tw-pics/top_bg.jpg) no-repeat center top;
        height: 210px;
    }

    .logo_tw {
        margin: 0 auto;
        width: 800px;
        height: 100px;
        padding-top: 57px;
    }

    .main_tw {
        width: 1000px;
        margin: 0 auto;
        overflow: hidden;
    }

    .main_tw > a {
        display: block;
        width: 269px;
        height: 166px;
        float: left;
        margin-left: 48px;
        border-radius: 8px;
        padding-top: 24px;
        margin-bottom: 48px;
        -webkit-transition: background .2s ease;
        -moz-transition: background .2s ease;
        -o-transition: background .2s ease;
    }

    .main_tw > a > span.mainBoxPic_tw {
        width: 70px;
        margin: 0 auto;
        background: url(../assets/img/tw-pics/ico_tw.png) no-repeat;
        display: block;
        height: 64px;
        -webkit-transition: background .2s ease;
        -moz-transition: background .2s ease;
        -o-transition: background .2s ease;
    }

    .main_tw > a > span.mainBoxTxt_tw {
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 20px;
        line-height: 26px;
        display: block;
        font-weight: bold;
        padding-top: 10px;
    }

    .main_tw > a.jcwsglnlts {
        background: #3ba7ce;
    }

    .main_tw > a.jcwsglnlts:hover {
        background: #1b81a6;
    }

    .main_tw > a.jcwsglnlts > span.mainBoxPic_tw {
        background-position: left top;
    }

    .main_tw > a.jcwsglnlts:hover > span.mainBoxPic_tw {
        background-position: -70px top;
    }

    .main_tw > a.jtysqyfwnljs {
        background: #25bd9b;
    }

    .main_tw > a.jtysqyfwnljs:hover {
        background: #0a8c6f;
    }

    .main_tw > a.jtysqyfwnljs > span.mainBoxPic_tw {
        background-position: left -64px;
    }

    .main_tw > a.jtysqyfwnljs:hover > span.mainBoxPic_tw {
        background-position: -70px -64px;
    }

    .main_tw > a.qkyxzljnts {
        background: #25bdbb;
    }

    .main_tw > a.qkyxzljnts:hover {
        background: #0e9896;
    }

    .main_tw > a.qkyxzljnts > span.mainBoxPic_tw {
        background-position: left -128px;
    }

    .main_tw > a.qkyxzljnts:hover > span.mainBoxPic_tw {
        background-position: -70px -128px;
    }

    .main_tw > a.jcsqhljnts {
        background: #25bdbb;
    }

    .main_tw > a.jcsqhljnts:hover {
        background: #0e9896;
    }

    .main_tw > a.jcsqhljnts > span.mainBoxPic_tw {
        background-position: left -192px;
    }

    .main_tw > a.jcsqhljnts:hover > span.mainBoxPic_tw {
        background-position: -70px -192px;
    }

    .main_tw > a.xcyszx {
        background: #3ba7ce;
    }

    .main_tw > a.xcyszx:hover {
        background: #1b81a6;
    }

    .main_tw > a.xcyszx > span.mainBoxPic_tw {
        background-position: left -256px;
    }

    .main_tw > a.xcyszx:hover > span.mainBoxPic_tw {
        background-position: -70px -256px;
    }

    .main_tw > a.sqqlyjryzx {
        background: #2bca81;
    }

    .main_tw > a.sqqlyjryzx:hover {
        background: #0ca65f;
    }

    .main_tw > a.sqqlyjryzx > span.mainBoxPic_tw {
        background-position: left -320px;
    }

    .main_tw > a.sqqlyjryzx:hover > span.mainBoxPic_tw {
        background-position: -70px -320px;
    }

    .main_tw > a.jszgfwzxzx {
        background: #25bdbb;
    }

    .main_tw > a.jszgfwzxzx:hover {
        background: #0e9896;
    }

    .main_tw > a.jszgfwzxzx > span.mainBoxPic_tw {
        background-position: left -384px;
    }

    .main_tw > a.jszgfwzxzx:hover > span.mainBoxPic_tw {
        background-position: -70px -384px;
    }

    .footer_tw {
        width: 100%;
        min-width: 1000px;
        height: 100px;
        background: url(../assets/img/tw-pics/footer_tw.png) repeat-x left top;
        font-size: 16px;
        line-height: 70px;
        text-align: center;
        color: #006db3;
        margin-top: 20px;
    }

    /*登录框*/
    .nlb_main {
        background: #fff;
        width: 100%;
        color: #555;
    }

    .nlb_main .nlb_main_bt {
        width: 100%;
        text-align: center;
        font-size: 20px;
        line-height: 40px;
    }

    .nlb_input {
        margin: 0px 10px;
        border: 1px #ddd solid;
        height: 36px;
        padding: 6px 0px 6px 10px;
        overflow: hidden;
        position: relative;
        margin-top: 20px;
    }

    .nlb_input span.nlbi_user {
        background-position: 8px -650px;
    }

    .nlb_input span.nlbi_pwd {
        background-position: 8px -690px;
    }

    .nlb_input input[type="text"] {
        width: 95%;
        border: 0;
        height: 24px;
        line-height: 24px;
        list-style: none;
        background: none;
        overflow: hidden;
    }

    .nlb_input input[type="password"] {
        width: 95%;
        border: 0;
        height: 24px;
        line-height: 24px;
        list-style: none;
        background: none;
        overflow: hidden;
    }

    .nlb_reme {
        height: 40px;
        line-height: 40px;
        position: relative;
        font-size: 14px;
        padding-left: 10px;
        margin-bottom: 15px;
    }

    .nlb_reme label {
        position: absolute;
        left: 20px;
        top: 0;
        height: 40px;
        padding-left: 20px;
        cursor: pointer;
        font-weight: normal;
    }

    .nlb_reme label input {
        position: absolute;
        left: 0;
        top: 12px;
    }

    .nlb_reme a {
        width: 40%;
        display: block;
        text-align: right;
        right: 10px;
        top: 0;
        position: absolute;
    }

    .nlb_btn {
        margin: 0px 10px;
        margin-top: 30px;
    }

    .nlb_btn input {
        width: 100%;
        height: 40px;
        background: #38bcd5;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        border: 0px;
        border-radius: 5px;
    }

    .nlb_btn input:hover {
        background: #28afc8;
    }

    .nlb_zc {
        line-height: 22px;
        padding-top: 8px;
        font-size: 16px;
        text-align: center;
    }

    .nlb_zc a {
        color: #38bcd5;
    }

    .nlb_zc a:hover {
        text-decoration: underline;
    }

    .nlb_main .nlb_main_role {
        margin: 0px 10px;
        overflow: hidden;
    }

    .nlb_main .nlb_main_role a {
        display: block;
        width: 50%;
        background: #dcdcdc;
        float: left;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #222;
        text-align: center;
    }

    .nlb_main .nlb_main_role a.nlb_main_role_sel {
        background: url(../assets/img/tw-pics/nlb_main_role_sel_bg.png) no-repeat center bottom #5da6e9;
        color: #fff;
    }

    .nlb_box {
        width: 100%;
    }
</style>

